import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Responsive from 'app/components/Responsive';

import './basket-check-get-discount.scss';


const sourceNames = {
    'trial-header': 'trial_first_screen',
    'trial-check': 'trial_check',
    basket: 'basket_check',
};


const titleTexts = {
    default: 'Заказываете впервые?',
    '5x2a': 'Заказываете впервые?',
    tinkoff: (
        <Responsive
            mobile="Только для клиентов Тинькофф! Скидка 30% + подарок 🧁"
            desktop="Скидка 30% и десерт в подарок"
        />
    ),
    beeline: (
        <Responsive
            mobile="Только для абонентов билайна! Скидка 30% + подарок 🍧"
            desktop="Скидка 30% и смузи в подарок"
        />
    ),
    besplatno: (
        <Responsive
            mobile="Скидка 30% + десерт в подарок"
            desktop="Скидка 30% + десерт в подарок"
        />
    ),
    harry: (
        <Responsive
            mobile="Скидка 30% + десерт в подарок"
            desktop="Скидка 30% + десерт в подарок"
        />
    ),
};


const linkAppNames = ['default', '5x2b'];


export function BasketCheckGetDiscount({
    env,
    handleOpenAuthDiscount,
    isWelcomeDiscountShown,
    appName = 'default',
}) {
    // eslint-disable-next-line react/destructuring-assignment
    const discountSize = 15;

    const onClick = () => {
        handleOpenAuthDiscount({ sourceName: sourceNames[env] });
    };

    const rootClasses = cn({
        'get-promo': true,
        [env]: env,
        confirmed: !isWelcomeDiscountShown,
    });

    const rowTwoClasses = cn({
        [appName]: true,
        'get-promo__row-two': true,
    });

    const titleText = titleTexts[appName];

    return (
        <div styleName={rootClasses}>
            {linkAppNames.includes(appName) && (
                <>
                    <div styleName="get-promo__row-one">
                        {titleText}
                    </div>
                    <button
                        type="button"
                        styleName={rowTwoClasses}
                        onClick={onClick}
                    >
                        Получите welcome-скидку
                        {' '}
                        {discountSize}
                        %!
                    </button>
                </>
            )}
        </div>
    );
}

BasketCheckGetDiscount.propTypes = {
    handleOpenAuthDiscount: PropTypes.func.isRequired,
    isWelcomeDiscountShown: PropTypes.bool.isRequired,
    env: PropTypes.oneOf(['basket', 'trial-header', 'trial-check']).isRequired,
    appName: PropTypes.string,
};
